import React, { ComponentProps } from 'react';
import styles from './styles.module.scss';

export const BoxMainValue = ({ children, className }: ComponentProps<'p'>) => <p className={`${styles['main-value']} ${className}`}>{children}</p>;
